import * as React from "react";

function SvgPartners(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <path
        d="M16.906 18.274h-1.188V3.258a.6.6 0 00-.594-.613h-4.456V1.113A.6.6 0 0010.074.5H5.953a.6.6 0 00-.594.613v1.532h-.483a.6.6 0 00-.594.613v15.016H3.094a.613.613 0 000 1.226h13.812a.613.613 0 000-1.226zM6.545 1.726H9.48v.919H6.545zm2.267 16.548v-2.6h2.376v2.6zm3.564 0v-2.6h.26a.613.613 0 000-1.226H7.364a.613.613 0 000 1.226h.26v2.6H5.47V3.871h9.059v14.4zM9.145 5.671a.6.6 0 01-.594.613h-.667a.613.613 0 010-1.226h.668a.6.6 0 01.593.613zm3.527 0a.6.6 0 01-.594.613h-.668a.613.613 0 010-1.226h.668a.6.6 0 01.595.613zM9.145 7.97a.6.6 0 01-.594.613h-.667a.613.613 0 010-1.226h.668a.6.6 0 01.593.613zm3.527 0a.6.6 0 01-.594.613h-.668a.613.613 0 010-1.226h.668a.6.6 0 01.595.613zm-3.527 2.298a.6.6 0 01-.594.613h-.667a.613.613 0 010-1.226h.668a.6.6 0 01.593.613zm3.527 0a.6.6 0 01-.594.613h-.668a.613.613 0 010-1.226h.668a.6.6 0 01.595.613zm-3.527 2.299a.6.6 0 01-.594.613h-.667a.613.613 0 010-1.226h.668a.6.6 0 01.593.613zm3.527 0a.6.6 0 01-.594.613h-.668a.613.613 0 010-1.226h.668a.6.6 0 01.595.613z"
        stroke="currentColor"
        strokeWidth={0.4}
        fill="currentColor"
        data-name="Grupo de m\xE1scara 38"
      />
    </svg>
  );
}

export default SvgPartners;

